import { useCallback, useEffect, useState } from "react";
import { useAuthHeader } from "react-auth-kit";

function useFetch(url) {
  const authHeader = useAuthHeader();
  const authHeaderValue = authHeader();

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(
    async (signal) => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_SERVER_URI}${url}`,
          {
            headers: { Authorization: authHeaderValue },
            signal,
          },
        );
        const jsonData = await response.json();
        setData(jsonData);
        setError(null);
      } catch (err) {
        if (err.name !== "AbortError") {
          setError(err);
        }
      } finally {
        setLoading(false);
      }
    },
    [url, authHeaderValue],
  );

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller.signal);
    return () => controller.abort();
  }, [fetchData]);

  const refresh = useCallback(() => {
    fetchData();
  }, [fetchData]);

  return { data, error, loading, refresh };
}

export default useFetch;
